import Vue from "vue";

export default {
  namespaced: true,
  state: {
    designerGenerationView: {
      prev: 'designer-models',
      next: 'designer-generations-questions',
      nextName: 'g_id',
      namePage: 'generations',
      data: 'generations/GENERATIONS',
      active: 'generations/GENERATION_EDIT',
      plusName: 'Добавить поколение',
      secondTitleName: ['models/MODEL'],
      secondTitle: true,
      addInfo: {
        name: 'Сложность',
        key: 'complexity'
      }
    },
    designerGenerationViewNew: {
      component: 'EditImg',
      prev: 'designer-generations',
      btnText: 'Добавить поколение',
      componentData: {
        send: 'generations/GENERATION_NEW',
        editImg: true,
        uploadText: 'Добавить фотографию поколения',
        inputs: [
          {
            component: 'InputSelect',
            name: 'start',
            label: 'Год начала и окончания выпуска поколения',
            labelClass: 'text-nowrap',
            className: 'col-sm-6 pr10',
            placeholder: 'Год начала',
            rules: {
              required: true
            }
          },
          {
            component: 'InputSelect',
            name: 'end',
            placeholder: 'Год окончания',
            className: 'col-sm-6 mt25 pl10',
            rules: {
              required: true
            },
            ref: 'endDate'
          },
          {
            component: 'InputText',
            name: 'body',
            label: 'Кузов',
          },
          {
            component: 'InputSelect',
            name: 'complexity',
            label: 'Сложность',
            rules: {
              required: true
            },
            options: [
              1,
              2,
              3,
              4,
              5
            ]
          }
        ]
      }
    },
    designerGenerationViewEdit: {
      component: 'EditImg',
      prev: 'designer-generations',
      btnText: 'Сохранить изменения',
      componentData: {
        data: 'generations/GENERATION',
        send: 'generations/GENERATION_EDIT',
        editImg: true,
        imgClass: 'card__img--small',
        uploadText: 'Выбрать новую фотографию',
        addInfo: {
          name: 'Сложность',
          key: 'complexity'
        },
        inputs: [
          {
            component: 'InputSelect',
            name: 'start',
            label: 'Год начала и окончания выпуска поколения',
            labelClass: 'text-nowrap',
            className: 'col-sm-6 pr10',
            placeholder: 'Год начала',
            rules: {
              required: true
            }
          },
          {
            component: 'InputSelect',
            name: 'end',
            placeholder: 'Год окончания',
            className: 'col-sm-6 mt25 mt-sm-0 pl10',
            rules: {
              required: true
            },
            ref: 'endDate'
          },
          {
            component: 'InputText',
            name: 'body',
            label: 'Кузов',
          },
          {
            component: 'InputSelect',
            name: 'complexity',
            label: 'Сложность',
            rules: {
              required: true
            },
            options: [
              1,
              2,
              3,
              4,
              5
            ]
          }
        ]
      }
    },
    designerGenerationViewDisable: {
      component: 'EditImg',
      prev: 'designer-generations',
      btnText: 'Отключить поколение',
      wrapClass: 'mt50',
      componentClass: 'img-wrap--higher flex-grow-1',
      formClass: 'edit--small',
      componentData: {
        data: 'generations/GENERATION',
        send: 'generations/GENERATION_EDIT',
        editImg: false,
        disable: true,
        addInfo: {
          name: 'Сложность',
          key: 'complexity'
        }
      }
    },
    designerGenerationViewDelete: {
      component: 'EditImg',
      prev: 'designer-generations',
      btnText: 'Удалить поколение',
      wrapClass: 'mt50',
      componentClass: 'img-wrap--higher flex-grow-1',
      formClass: 'edit--small',
      componentData: {
        data: 'generations/GENERATION',
        send: 'generations/GENERATION_DELETE',
        editImg: false,
        addInfo: {
          name: 'Сложность',
          key: 'complexity'
        }
      }
    },
    checkGenerationView: {
      prev: 'check-models',
      next: 'check-questions',
      namePage: 'generations',
      nextName: 'g_id',
      data: 'generations/GENERATIONS',
      designer: false,
      titleClass: 'text-no-transform'
    }
  },
  actions: {
    'GENERATIONS': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}generations/${params.brand}/${params.m_id}`, )
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'GENERATION': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}generations/${params.brand}/${params.m_id}/${params.id}`)
        .then(
          res => {
            res.body = res.body[0];
            res.body.start = res.body.name.split('-')[0];
            res.body.end = res.body.name.split('-')[1];
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'GENERATION_NEW': async (context, params) => {
      params.file_name = params.photo;
      delete params.photo;
      params.generation_name = params.start + '-' + params.end;
      delete params.start;
      delete params.end;
      let formData = new FormData();
      for (let key in params) {
        formData.append(key+ "", params[key]);
      }
      return await Vue.http.post(`${process.env.VUE_APP_API_URL}generations`, formData)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'GENERATION_EDIT': async (context, params) => {
      params.file_name = params.photo;
      delete params.photo;
      params.g_id = params.id;
      delete params.id;
      if (params.start !== undefined && params.end !== undefined) {
        params.name = params.start + '-' + params.end;
      }
      delete params.start;
      delete params.end;
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      return await Vue.http.put(`${process.env.VUE_APP_API_URL}generations`, formData)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'GENERATION_DELETE': async (context, params) => {
      params.photo = params.photo.split('/');
      params.photo = params.photo[params.photo.length - 1];
      return await Vue.http.delete(`${process.env.VUE_APP_API_URL}generations/${params.brand}/${params.m_id}/${params.id}/${params.photo}`)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
  }
}